/**!
 * Copyright 2016 xdot GmbH
 *
 * Author: Carsten Hibbeler
 * Date: 07.09.2016
 *
 */

import React from 'external/react';
import ReactDOM from 'external/react-dom';
import PropTypes from 'external/prop-types';
import { Alert, Card, ListGroup, ListGroupItem } from 'external/react-bootstrap';

const style = {
    whiteSpace: 'nowrap',
    position: 'fixed',
    left: '25%',
    bottom: 20,
    width: 'fit-content',
    minWidth: '50%',
    margin: 0,
    background: 'white',
    border: 'none'
};

const alertStyle = {
    padding: 15,
    fontSize: 16
};

const WebSocketStateWindow = ({ connected, wsReadyState, serverActivity }) => {

    if (connected) {
        return null;
    }

    return (
        <Card style={style}>
            <Card.Body>
                <Alert variant="warning" style={alertStyle}>
                    <i className="icon-fliwas-alert-inverse"/>
                    <b>&nbsp;Mögliche Verzögerungen in der Internetverbindung</b>:
                    Aktualisierung der Inhalte eventuell eingeschränkt.&nbsp;

                    <br/>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://infoportal.fliwas3.de/start/service/hinweis_+moegliche+verzoegerungen+in+der+internetverbindung.html"
                    >
                        Klicken Sie hier für weitere Informationen.
                    </a>
                </Alert>
                {
                    __DEBUG__ &&
                    <ListGroup>
                        <ListGroupItem>Websocket letzte
                            Server-Aktivität: {serverActivity && new Date(serverActivity).toLocaleString()}</ListGroupItem>
                        <ListGroupItem>Websocket readyState: {wsReadyState}</ListGroupItem>
                    </ListGroup>
                }
            </Card.Body>
        </Card>
    );
};

WebSocketStateWindow.propTypes = {
    connected: PropTypes.bool,
    wsReadyState: PropTypes.string,
    serverActivity: PropTypes.number

};

let node = null;

export default function InitWebSocketStateComponent(props){

    if (!node) {
        node = document.getElementById('websocket-status') || document.createElement('div');
        node.setAttribute('id', 'websocket-status');
        document.body.appendChild(node);
    }

    ReactDOM.render(React.createElement(WebSocketStateWindow, props), node);
}



// WEBPACK FOOTER //
// ./js/components/WebSocketStateWindow.jsx